export const Action = {
  UpdateProfile: 'UpdateProfile',
  UpdateUnreadCount: 'UpdateUnreadCount'
};

export const actions = (dispatch) => ({
  updateProfile: (profile) => dispatch({
    type: Action.UpdateProfile,
    payload: profile
  }),
  updateUnreadCount: (source, count) => dispatch({
    type: Action.UpdateUnreadCount,
    payload: { source, count }
  })
});
